// Listed up front; the view itself (./circle-of-fifths.tsx) loads on demand.
export const id = 'circle-of-fifths';
export const title = 'Circle of fifths';
export const order = 40;
